import React from 'react'
import CounsellingHomeHeaderSkeleton from './CounselingHomeHeaderSkeleton'

const CounsellingProfilesListSkeleton = () => {
    return (
        <div className="flex flex-col pr-[18px] animate-pulse w-full">
            {[...Array(6)].map((_, idx) => (
                <div key={idx} className="well-tracker-card flex items-center gap-4 bg-[#ecebf8] rounded-[5px] p-5">
                    <div className="flex flex-col gap-2 flex-1">
                        <div className="h-5 w-[120px] bg-lightBG rounded opacity-50"></div>
                        <div className="h-4 w-[80px] bg-lightBG rounded opacity-30"></div>
                    </div>
                    <div style={{ flex: 1 }}></div>
                    <div className="h-6 w-[80px] bg-lightBG rounded opacity-30"></div>
                    <div className="well-arrow-right ml-4">
                        <div className="h-8 w-8 bg-lightBG rounded-full opacity-50"></div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default CounsellingProfilesListSkeleton
